import { times } from 'lodash/fp'

import { Box, HStack, Tag } from '@masterplandev/ui'

export function PollFormProgress({ activeStep, countSteps }) {
  return (
    <HStack spacing="4">
      <HStack>
        {times(
          (index) => (
            <Box
              key={index}
              w={index === activeStep ? 8 : 3}
              h="1"
              bg="white"
              opacity={index <= activeStep ? '100%' : '65%'}
              borderRadius="full"
            />
          ),
          countSteps,
        )}
      </HStack>
      <Tag
        color="mpWhite.400"
        bg="mpWhite.200"
        minW="10"
        justifyContent="center">
        {`${activeStep + 1}/${countSteps}`}
      </Tag>
    </HStack>
  )
}
